import { render, staticRenderFns } from "./menuMgr.vue?vue&type=template&id=752d5d01"
import script from "./menuMgr.vue?vue&type=script&lang=js"
export * from "./menuMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports